import type Email from '../../interfaces/Email';

export type ComposerMode = 'new' | 'reply' | 'forward' | 'draft';

export interface ComposerContext {
  mode: ComposerMode;
  email: Email;
  includeAttachments?: boolean;
  replyAll?: boolean;
  protectionPassword?: string;
}

export interface EmailSlice {
  isEmailComposerOpen: boolean;
  isSendOverlayVisible: boolean;
  composerContext: ComposerContext | null;
  emailUnreadCount: number;
  openEmailComposer: () => void;
  openEmailComposerWith: (ctx: ComposerContext) => void;
  closeEmailComposer: () => void;
  showSendOverlay: () => void;
  hideSendOverlay: () => void;
  setEmailUnreadCount: (count: number) => void;
  fetchEmailUnreadCount: () => Promise<void>;
}

export const createEmailSlice = (set: any): EmailSlice => ({
  isEmailComposerOpen: false,
  isSendOverlayVisible: false,
  composerContext: null,
  emailUnreadCount: 0,
  openEmailComposer: () => set({ isEmailComposerOpen: true, composerContext: null }),
  openEmailComposerWith: (ctx: ComposerContext) =>
    set({ isEmailComposerOpen: true, composerContext: ctx }),
  closeEmailComposer: () => set({ isEmailComposerOpen: false, composerContext: null }),
  showSendOverlay: () => set({ isSendOverlayVisible: true }),
  hideSendOverlay: () => set({ isSendOverlayVisible: false }),
  setEmailUnreadCount: (count: number) => set({ emailUnreadCount: count }),
  fetchEmailUnreadCount: async () => {
    try {
      const { emailService } = await import('../../services/emailApiService');
      const count = await emailService.getUnreadCount();
      set({ emailUnreadCount: count });
    } catch {
      // Silently fail — badge will show stale/cached value
    }
  },
});
